import { createContext, useContext } from "react";

export type CrossHairState = {
  show: boolean;
  offset: number;
  stringifiedTime: string;
  seconds: number;
  realSeconds: number;
  isOnMarker: boolean;
  markerLabel?: string;
};

export const CrossHairContext = createContext<CrossHairState | undefined>(
  undefined
);

export const useCrossHair = () => {
  const context = useContext(CrossHairContext);

  if (context === undefined) {
    throw new Error("useCrossHair must be used within a CrossHairProvider");
  }

  return context;
};
